import React, { memo } from "react";
import Helmet from "react-helmet";
import { FB_APP_ID } from "../base";

declare global {
    interface Window {
        launchWhatsAppSignup: any;
    }
}

const FacebookSDK = () => {
    if(window.launchWhatsAppSignup){
        return null
    }
    return (
        <Helmet>
            <script src="/fb-sdk.js" data-id="FB_APP_ID" data-FB_APP_ID={FB_APP_ID}></script>
            <script async defer crossOrigin="anonymous" src="https://connect.facebook.net/en_US/all.js"></script>
        </Helmet>
    )
}

export default memo(FacebookSDK);